import * as React from "react";
import { Icon, IIconProps } from "./Icon";
import { Spinner } from "./Spinner";
import { Logo } from "./Logo";
import { AnimatePresence, motion } from "framer-motion";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
import * as Portal from "@radix-ui/react-portal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { agregarToken, cerrarMenu } from "../../features/ui/uiSlice";
import { useGetMenuQuery } from "../../services/docs";

// ---
// Menú que contiene el menú de escritorio y el menú de móvil
// ---
export interface IMenuProps {
  items: IItemMenuProps[];
}

const Menu = (): JSX.Element => {
  const { data, isLoading } = useGetMenuQuery();
  return (
    <div className="sticky left-0 top-0 flex min-h-full w-min flex-row items-start justify-start gap-1 bg-light shadow-right">
      <div className="relative h-full w-full">
        {isLoading || (!data && <Spinner />)}
        {data && (
          <>
            <MenuEscritorio items={data.menu} />
            <MenuMovil items={data.menu} />
          </>
        )}
      </div>
    </div>
  );
};

// ---
// End of Menú que contiene el menú de escritorio y el menú de móvil
// ---

// ---
// Menú de escritorio
// ---

export interface IMenuEscritorioProps {
  items: IItemMenuProps[];
}

export const MenuEscritorio = ({
  items,
}: IMenuEscritorioProps): JSX.Element => {
  const navigate = useNavigate();
  const { usuario, menu } = useSelector((state: RootState) => state.ui);
  const dispatch = useDispatch();
  const cerrarSesion = () => {
    dispatch(agregarToken(""));
    navigate("/auth/login", { replace: true });
  };
  const cambiarMenu = () => {
    dispatch(cerrarMenu());
  };
  return (
    <div
      className={
        menu
          ? "relative hidden h-full w-[240px] shrink-0 flex-col items-start justify-start gap-6 pb-0 pl-0 pr-0 pt-6 md:flex"
          : "relative hidden h-full w-[70px] shrink-0 flex-col items-start justify-start gap-6 pb-0 pl-0 pr-0 pt-6 md:flex"
      }
    >
      <div
        onClick={cambiarMenu}
        className="flex w-full cursor-pointer justify-end pr-5"
      >
        {menu ? (
          <Icon variante={"chevron-left"} />
        ) : (
          <Icon variante={"chevron-right"} />
        )}
      </div>
      <Link
        to={"/"}
        className={
          menu
            ? "relative flex shrink-0 flex-col items-center justify-start gap-2 self-stretch pb-6 pl-4 pr-4 pt-6"
            : "relative flex shrink-0 flex-col items-center justify-start gap-1  "
        }
      >
        <img
          alt="insuranceservices pattern"
          src="/images/logo.png"
          width={menu ? "100%" : "100%"}
        />
      </Link>

      <div
        className={
          "relative flex shrink-0 flex-row items-start justify-start gap-2 self-stretch pb-0 pl-4 pr-4 pt-0"
        }
      >
        {/* <div className={"w-full text-dark text-left"}><span className="bg-primary text-white text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-primary dark:text-white">{user.fc_perfil}</span></div> */}
        <div className={"flex w-full flex-col text-left text-dark"}>
          {/* {usuario && ( */}
          {/*   <> */}
          {/*     <div className="mb-2 w-full"> */}
          {/*       <span className="mr-2 rounded-full bg-primary px-2.5 py-0.5 text-xs font-medium text-white dark:bg-primary dark:text-white"> */}
          {/*         {/* {usuario.profile.toUpperCase()} */}
          {/*       </span> */}
          {/*       <span */}
          {/*         onClick={cerrarSesion} */}
          {/*         className="mr-2 rounded-full bg-gray-dark px-2.5 py-0.5 text-xs font-medium text-white dark:bg-gray-dark dark:text-white" */}
          {/*       > */}
          {/*         Salir */}
          {/*       </span> */}
          {/*     </div> */}
          {/*     <span className="w-full"> */}
          {/*       Hola,{" "} */}
          {/*       {usuario.nombreUsuario.replace(/^\w/, (c: string) => */}
          {/*         c.toUpperCase() */}
          {/*       )}{" "} */}
          {/*       {usuario.appUsuario.replace(/^\w/, (c: string) => */}
          {/*         c.toUpperCase() */}
          {/*       )} */}
          {/*     </span> */}
          {/*   </> */}
          {/* )} */}
        </div>
      </div>

      <div
        className={
          "relative flex shrink-0 flex-row items-start justify-start gap-2 self-stretch pb-0 pl-4 pr-4 pt-0"
        }
      ></div>
      <nav className="w-full space-y-0 overflow-auto">
        {items?.map((item, index) => (
          <MenuItemComponent
            key={index}
            item={item}
            currentPath={location.pathname.replace("/CRM/", "/")}
          />
        ))}
      </nav>
    </div>
  );
};

// ---
// End of Menú de escritorio
// ---

const MenuItemComponent = ({
  item,
  currentPath,
}: {
  item: any;
  currentPath: string;
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const hasSubItems = item.submenus && item.submenus.length > 0;
  const isActive =
    currentPath === item.fc_ruta ||
    item.submenus?.some((subItem: any) => subItem.fc_ruta === currentPath);
  const { menu } = useSelector((state: RootState) => state.ui);
  return (
    <div className="group relative ">
      <Link
        to={!hasSubItems && item.fc_ruta}
        onClick={() => hasSubItems && setIsOpen(!isOpen)}
        className={`flex items-center justify-between p-4 transition-colors hover:bg-gray-100
          ${isActive ? "font-semibold text-primary" : "text-gray-700"}`}
      >
        <div className="flex items-center gap-3">
          <Icon variante={item.fc_icon} />
          {menu && <span>{item.fc_menu}</span>}
        </div>

        {hasSubItems && (
          <motion.span animate={{ rotate: isOpen ? 180 : 0 }} className="ml-2">
            ▼
          </motion.span>
        )}
      </Link>

      <AnimatePresence>
        {hasSubItems && isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="pl-6"
          >
            {item.submenus?.map((subItem, index) => (
              <MenuItemComponent
                key={index}
                item={subItem}
                currentPath={currentPath}
              />
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      {isActive && (
        <motion.div
          className="absolute inset-y-0 left-0 w-1 bg-primary"
          layoutId="activeIndicator"
        />
      )}
    </div>
  );
};

// ---
// Menú de móvil
// ---

export interface IMenuMovilProps {
  items: IItemMenuProps[];
}
export const MenuMovil = ({ items }): JSX.Element => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <Portal.Root>
      <div className={"fixed bottom-4 right-4 !z-[999] xl:hidden"}>
        <div className={"relative"}>
          <Popover open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
            <PopoverTrigger asChild>
              {/* Icono de menú */}
              <motion.div
                className={
                  "flex h-12 w-12 cursor-pointer items-center justify-center overflow-hidden rounded-full bg-light shadow-xl"
                }
              >
                <Icon variante={isOpen ? "x" : "menu"} color="dark" size={32} />
              </motion.div>
              {/* End of Icono de menú */}
            </PopoverTrigger>
            <PopoverContent className="mr-6 p-0">
              <motion.div className={"w-full space-y-0"}>
                {items?.map((item, i) => (
                  <ItemMenu key={i} {...item} />
                ))}
              </motion.div>
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </Portal.Root>
  );
};

// ---
// End of Menú de móvil
// ---

// ---
// Item de menú
// ---

export interface IItemMenuProps {
  estado?: "activo" | "inactivo" | "deshabilitado";
  label: string;
  icono: IIconProps["variante"];
  onClick: () => void;
  href: string;
}

const ItemMenu = ({
  estado = "activo",
  label,
  icono,
  href,
}: IItemMenuProps): JSX.Element => {
  const height = 60;
  const location = useLocation();
  return (
    <div className={"relative"}>
      <Link
        to={href || "#"}
        className={
          "relative flex shrink-0 flex-row items-center justify-start gap-4 self-stretch overflow-hidden"
        }
      >
        <motion.div
          className={`relative flex flex-1 flex-row items-center justify-start gap-4 px-4`}
          initial={{ height }}
          animate={{
            height,
            color: estado === "activo" ? "primary" : "dark",
          }}
        >
          <Icon variante={icono} />

          <div className={`relative flex-1 text-left`}>{label}</div>
        </motion.div>
      </Link>
      {/*  Indicador de activo */}
      <AnimatePresence mode="sync">
        {href === location.pathname && (
          <motion.div
            layoutId="menuItemActivoIndicador"
            initial={{ height }}
            className={`absolute inset-0 z-[0] w-full border-l-4 border-primary bg-primary/10 md:border-l-0 md:border-r-4`}
          />
        )}
      </AnimatePresence>
      {/*  End of Indicador de activo */}
    </div>
  );
};

// ---
// End of Item de menú
// ---

export default Menu;
